import { render, staticRenderFns } from "./ColorInput.vue?vue&type=template&id=b14d7ff4&scoped=true"
import script from "./ColorInput.vue?vue&type=script&lang=js"
export * from "./ColorInput.vue?vue&type=script&lang=js"
import style0 from "./ColorInput.vue?vue&type=style&index=0&id=b14d7ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14d7ff4",
  null
  
)

export default component.exports